module.exports = __webpack_public_path__ + "img/LogoATT-w400.26d99961.png";